import {RemotePostVoiceTranscriptionTermsAccept} from 'data/usecases/others/voice-transcription';
import {PostVoiceTranscriptionTermsAccept} from 'domain/usecases/others/voice-transcription';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {VoiceTranscriptionEndpoints} from '../../endpoints';

export const makePostVoiceTranscriptionTermsAccept = (): PostVoiceTranscriptionTermsAccept =>
	new RemotePostVoiceTranscriptionTermsAccept(
		makeBFFApiUrl(VoiceTranscriptionEndpoints.termsAccept),
		makeAuthorizeHttpClientDecorator(),
	);
